import { render, staticRenderFns } from "./startEvent.vue?vue&type=template&id=959a70ce"
import script from "./startEvent.vue?vue&type=script&lang=ts"
export * from "./startEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports